import _taggedTemplateLiteral from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: block;\n      }\n\n      [hidden] {\n        display: none;\n      }\n    </style>\n\n    <div part=\"row\">\n      <div part=\"info\">\n        <div part=\"done-icon\" hidden$=\"[[!file.complete]]\"></div>\n        <div part=\"warning-icon\" hidden$=\"[[!file.error]]\"></div>\n\n        <div part=\"meta\">\n          <div part=\"name\" id=\"name\">[[file.name]]</div>\n          <div part=\"status\" hidden$=\"[[!file.status]]\" id=\"status\">[[file.status]]</div>\n          <div part=\"error\" id=\"error\" hidden$=\"[[!file.error]]\">[[file.error]]</div>\n        </div>\n      </div>\n      <div part=\"commands\">\n        <div part=\"start-button\" file-event=\"file-start\" on-click=\"_fireFileEvent\" hidden$=\"[[!file.held]]\"></div>\n        <div part=\"retry-button\" file-event=\"file-retry\" on-click=\"_fireFileEvent\" hidden$=\"[[!file.error]]\"></div>\n        <div part=\"clear-button\" file-event=\"file-abort\" on-click=\"_fireFileEvent\"></div>\n      </div>\n    </div>\n\n    <vaadin-progress-bar part=\"progress\" id=\"progress\" value$=\"[[_formatProgressValue(file.progress)]]\" error$=\"[[file.error]]\" indeterminate$=\"[[file.indeterminate]]\" uploading$=\"[[file.uploading]]\" complete$=\"[[file.complete]]\">\n    </vaadin-progress-bar>\n"], ["\n    <style>\n      :host {\n        display: block;\n      }\n\n      [hidden] {\n        display: none;\n      }\n    </style>\n\n    <div part=\"row\">\n      <div part=\"info\">\n        <div part=\"done-icon\" hidden\\$=\"[[!file.complete]]\"></div>\n        <div part=\"warning-icon\" hidden\\$=\"[[!file.error]]\"></div>\n\n        <div part=\"meta\">\n          <div part=\"name\" id=\"name\">[[file.name]]</div>\n          <div part=\"status\" hidden\\$=\"[[!file.status]]\" id=\"status\">[[file.status]]</div>\n          <div part=\"error\" id=\"error\" hidden\\$=\"[[!file.error]]\">[[file.error]]</div>\n        </div>\n      </div>\n      <div part=\"commands\">\n        <div part=\"start-button\" file-event=\"file-start\" on-click=\"_fireFileEvent\" hidden\\$=\"[[!file.held]]\"></div>\n        <div part=\"retry-button\" file-event=\"file-retry\" on-click=\"_fireFileEvent\" hidden\\$=\"[[!file.error]]\"></div>\n        <div part=\"clear-button\" file-event=\"file-abort\" on-click=\"_fireFileEvent\"></div>\n      </div>\n    </div>\n\n    <vaadin-progress-bar part=\"progress\" id=\"progress\" value\\$=\"[[_formatProgressValue(file.progress)]]\" error\\$=\"[[file.error]]\" indeterminate\\$=\"[[file.indeterminate]]\" uploading\\$=\"[[file.uploading]]\" complete\\$=\"[[file.complete]]\">\n    </vaadin-progress-bar>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { ThemableMixin } from '@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js';
import '@vaadin/vaadin-progress-bar/src/vaadin-progress-bar.js';
import './vaadin-upload-icons.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
/**
 * `<vaadin-upload-file>` element represents a file in the file list of `<vaadin-upload>`.
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ---|---
 * `row` | File container
 * `info` | Container for file status icon, file name, status and error messages
 * `done-icon` | File done status icon
 * `warning-icon` | File warning status icon
 * `meta` | Container for file name, status and error messages
 * `name` | File name
 * `error` | Error message, shown when error happens
 * `status` | Status message
 * `commands` | Container for file command icons
 * `start-button` | Start file upload button
 * `retry-button` | Retry file upload button
 * `clear-button` | Clear file button
 * `progress`| Progress bar
 *
 * The following state attributes are available for styling:
 *
 * Attribute | Description | Part name
 * ---|---|---
 * `error` | An error has happened during uploading | `:host`
 * `indeterminate` | Uploading is in progress, but the progress value is unknown | `:host`
 * `uploading` | Uploading is in progress | `:host`
 * `complete` | Uploading has finished successfully | `:host`
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * @memberof Vaadin
 * @mixes Vaadin.ThemableMixin
 * @demo demo/index.html
 */

var UploadFileElement =
/*#__PURE__*/
function (_ThemableMixin) {
  _inherits(UploadFileElement, _ThemableMixin);

  function UploadFileElement() {
    _classCallCheck(this, UploadFileElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(UploadFileElement).apply(this, arguments));
  }

  _createClass(UploadFileElement, [{
    key: "_fileAborted",
    value: function _fileAborted(abort) {
      if (abort) {
        this._remove();
      }
    }
  }, {
    key: "_remove",
    value: function _remove() {
      this.dispatchEvent(new CustomEvent('file-remove', {
        detail: {
          file: this.file
        },
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "_formatProgressValue",
    value: function _formatProgressValue(progress) {
      return progress / 100;
    }
  }, {
    key: "_fireFileEvent",
    value: function _fireFileEvent(e) {
      e.preventDefault();
      return this.dispatchEvent(new CustomEvent(e.target.getAttribute('file-event'), {
        detail: {
          file: this.file
        },
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "_toggleHostAttribute",
    value: function _toggleHostAttribute(value, attributeName) {
      var shouldHave = Boolean(value);
      var has = this.hasAttribute(attributeName);

      if (has !== shouldHave) {
        if (shouldHave) {
          this.setAttribute(attributeName, '');
        } else {
          this.removeAttribute(attributeName);
        }
      }
    }
    /**
    * Fired when the retry button is pressed. It is listened by `vaadin-upload`
    * which will start a new upload process of this file.
    *
    * @event file-retry
    * @param {Object} detail
    * @param {Object} detail.file file to retry upload of
    */

    /**
    * Fired when the start button is pressed. It is listened by `vaadin-upload`
    * which will start a new upload process of this file.
    *
    * @event file-start
    * @param {Object} detail
    * @param {Object} detail.file file to start upload of
    */

    /**
     * Fired when abort button is pressed. It is listened by `vaadin-upload` which
     * will abort the upload in progress, but will not remove the file from the list
     * to allow the animation to hide the element to be run.
     *
     * @event file-abort
     * @param {Object} detail
     * @param {Object} detail.file file to abort upload of
     */

    /**
     * Fired after the animation to hide the element has finished. It is listened
     * by `vaadin-upload` which will actually remove the file from the upload
     * file list.
     *
     * @event file-remove
     * @param {Object} detail
     * @param {Object} detail.file file to remove from the  upload of
     */

  }], [{
    key: "template",
    get: function get() {
      return html(_templateObject());
    }
  }, {
    key: "is",
    get: function get() {
      return 'vaadin-upload-file';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        file: Object
      };
    }
  }, {
    key: "observers",
    get: function get() {
      return ['_fileAborted(file.abort)', '_toggleHostAttribute(file.error, "error")', '_toggleHostAttribute(file.indeterminate, "indeterminate")', '_toggleHostAttribute(file.uploading, "uploading")', '_toggleHostAttribute(file.complete, "complete")'];
    }
  }]);

  return UploadFileElement;
}(ThemableMixin(PolymerElement));

customElements.define(UploadFileElement.is, UploadFileElement);
export { UploadFileElement };